'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const elDescriptionsKey = "elDescriptions";

exports.elDescriptionsKey = elDescriptionsKey;
//# sourceMappingURL=token.js.map
